import { render, staticRenderFns } from "./ImportacaoModal.vue?vue&type=template&id=73d72960"
import script from "./ImportacaoModal.vue?vue&type=script&lang=js"
export * from "./ImportacaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports